import { render, staticRenderFns } from "./canceled.vue?vue&type=template&id=b215f094&scoped=true"
import script from "./canceled.vue?vue&type=script&lang=js"
export * from "./canceled.vue?vue&type=script&lang=js"
import style0 from "./canceled.vue?vue&type=style&index=0&id=b215f094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b215f094",
  null
  
)

export default component.exports